import toast from 'react-hot-toast';
import { PaymentIntentOrSetupIntentResult } from '@stripe/stripe-js';

import { setPaymentLoad, StripePaymentStatus } from '@pharmaplan/common';

import { useAppDispatch } from '../useAppDispatch';
import { resetDialog } from '../../reducers/dialogReducer';
import { showPaymentError } from '../../components/PaymentGateway/PaymentGateway';

const usePaymentCheckStatus = () => {
  const dispatch = useAppDispatch();

  const checkPaymentStatus = (onSuccess: () => void, onError?: () => void) =>
    (res: PaymentIntentOrSetupIntentResult) => {
      const { error, paymentIntent } = res ?? {};
      if (error) {
        showPaymentError(dispatch, error?.message ?? '');
        toast.dismiss();
        dispatch(setPaymentLoad(false));
        onError?.();
      }

      switch (paymentIntent?.status) {
        case StripePaymentStatus.succeeded:
          onSuccess();
          break;
        case StripePaymentStatus.processing:
        case StripePaymentStatus.canceled:
          toast.dismiss();
          showPaymentError(dispatch, paymentIntent?.description ?? '');
          dispatch(resetDialog());
          dispatch(setPaymentLoad(false));
          onError?.();
          break;
        default:
          break;
      }
    };

  return { checkPaymentStatus };
};

export default usePaymentCheckStatus;
